/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {
  downloadJobAuditDialogChanges,
  downloadJobAuditNotifications,
  downloadJobIsAuditNotifications,
  downloadJobIsAuditRecord
} from '../selectors/downloadjobs';

/**
 * React Hook to provide selector/state for displaying Audit Logs in Download Job.
 * 
 *  ```typescript
 *   import {useDownloadJobAudit} from '@/routes/provisioning/downloadjob';
 * 
 *   const {
 *     showAuditNotification,
 *     auditNotification,
 *     selectedAuditRecord,
 *     showAuditChangesDialog
 *   } = useDownloadJobAudit();
 *  ```
 */
export const useDownloadJobAudit = () => {
  const showAuditNotification  = useSelector(downloadJobIsAuditNotifications);
  const auditNotification      = useSelector(downloadJobAuditNotifications);
  const selectedAuditRecord    = useSelector(downloadJobIsAuditRecord);
  const showAuditChangesDialog = useSelector(downloadJobAuditDialogChanges);

  return {
    showAuditNotification,
    auditNotification,
    selectedAuditRecord,
    showAuditChangesDialog
  };
};
